import { tryParseJSON } from "@eventr/common";
import { ColoursObj } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { cardTranslation } from "i18n/translateHelpers";
import { CardText } from "../subComponents/cardText";
import { RowInfoFiles } from "../subComponents/rowInfoFiles";
import { RowInfoNotes } from "../subComponents/rowInfoNotes";
import { RowInfoPhone } from "../subComponents/rowInfoPhone";
import { RowInfoStandart } from "../subComponents/RowInfoStandart";
import { RowInfoWeb } from "../subComponents/rowInfoWeb";
interface HotelAttachmentsProps {
  phoneNumber?: string;
  extra_docs?: string;
  notes?: string;
  website?: string;
  contactName?: string;
}

export const HotelAttachments = ({ extra_docs, notes, website, phoneNumber, contactName }: HotelAttachmentsProps) => {
  const files = useMemo(() => {
    if (!extra_docs) return [];
    return tryParseJSON(extra_docs, []) as string[];
  }, [extra_docs]);

  if (!files.length && !notes && !phoneNumber && !website) return null;
  return (
    <Stack spacing="8px" sx={{
      paddingBottom: "8px"
    }}>
      <CardText variant="bodyBold">{cardTranslation("Attachments")}</CardText>
      {contactName && <RowInfoStandart icon="User" bubbleColour={ColoursObj.core.secondary} middle={contactName} />}
      {phoneNumber && <RowInfoPhone phoneNumber={phoneNumber} />}
      {website && <RowInfoWeb website={website} />}
      {notes && <RowInfoNotes notes={notes} />}
      {files && <RowInfoFiles files={files} />}
    </Stack>
  );
};
